import {
  Alert,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  Link,
  TextField,
} from '@mui/material';
import React from 'react';
import {
  ActionButton,
  CancelButton,
  PurchaseDialogActions,
  PurchaseDialogInfoText,
  PurchaseDialogSubtitle,
  PurchaseDialogTitle,
} from './purchase/style';

class RedeemAccessToken extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDialog: false,
      inviteCode: null,
      isProcessingInviteCode: false,
      inviteCodeError: null,
    };
  }

  hideDialog() {
    this.props.hideDialog();
  }

  updateInviteCode(code) {
    this.setState({ ...this.state, inviteCode: code });
  }

  redeemCode() {
    const currentState = this.state;
    currentState.isProcessingInviteCode = true;
    this.setState(currentState);

    if (this.state.inviteCode) {
      this.props.subscription.redeemInviteCode(this.state.inviteCode, (redeemStatus) => {
        currentState.isProcessingInviteCode = false;
        if (redeemStatus === 'ok') {
          this.setState(currentState);
          window.location.reload();
        } else {
          currentState.inviteCodeError =
            redeemStatus === 'full'
              ? 'The subscription you tried to join is full. Please contact your administrator.'
              : 'We were not able to process the invite code. Please verify the code';
          this.setState(currentState);
        }
      });
    } else {
      currentState.isProcessingInviteCode = false;
      currentState.inviteCodeError = 'No invite code was entered.';
      this.setState(currentState);
    }
  }

  render() {
    return (
      <Dialog
        open={this.props.showDialog}
        onClose={() => this.hideDialog()}
        maxWidth="sm"
        fullWidth
      >
        <PurchaseDialogTitle>Join a shared subscription</PurchaseDialogTitle>
        <DialogContent>
          {this.props.allowInviteCode ? (
            <div>
              <PurchaseDialogSubtitle variant="subtitle2" color="textPrimary">
                An invite code allows you to join a shared subscription.
              </PurchaseDialogSubtitle>
              {this.state.inviteCodeError && (
                <Alert severity="warning" sx={{ marginBottom: 2 }}>
                  {this.state.inviteCodeError}
                </Alert>
              )}
              <TextField
                placeholder="Paste your invite code here"
                autoFocus
                fullWidth
                value={this.state.inviteCode || ''}
                onChange={(evt) => {
                  this.updateInviteCode(evt.target.value);
                }}
                sx={{ marginTop: 2, marginBottom: 2 }}
              />
              <PurchaseDialogInfoText variant="caption" color="textSecondary">
                By using an invite code, you allow us to share your contact details with the
                subscription owner in accordance with our{' '}
                <Link href="https://www.55degrees.se/privacy-policy" target="terms">
                  privacy policy
                </Link>
                .
              </PurchaseDialogInfoText>
            </div>
          ) : (
            <div>
              <PurchaseDialogSubtitle variant="subtitle2" color="textPrimary">
                This subscription contains multiple users. When you join another subscription, this
                one will be canceled. Before you can proceed, please remove all users from this
                subscription. If you have questions or concerns, please{' '}
                <Link
                  href="https://55degrees.atlassian.net/servicedesk/customer/portal/2/group/4/create/10"
                  target="terms"
                >
                  open a support request
                </Link>
                .
              </PurchaseDialogSubtitle>
            </div>
          )}
        </DialogContent>
        <PurchaseDialogActions>
          <CancelButton onClick={() => this.hideDialog()} color="primary">
            Okay
          </CancelButton>
          {this.props.allowInviteCode && (
            <ActionButton
              variant="contained"
              color="primary"
              disabled={this.state.isProcessingInviteCode}
              onClick={() => this.redeemCode()}
            >
              Redeem invite code
            </ActionButton>
          )}
        </PurchaseDialogActions>
      </Dialog>
    );
  }
}

export default RedeemAccessToken;
